// extracted by mini-css-extract-plugin
export default {"wrapper":"OnlyHeaderLayout_wrapper__1sbIJ","content":"OnlyHeaderLayout_content__s2I2M"};